import { Box, Container, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { customerViewRequest } from "../../../redux/customer/CustomerAction";
import { StyledContainer, styles } from "../../components/formStyles";
import CustomButton from "../../constant/commonButton";
import ReusableFormFields from "../../constant/reusableFormFields";
import { APP_LINK } from "../../global/MenuItems";
import uploadImage from "../../../image/wmremove-transformed-Photorooms.jpg";
import ImagePreviewDialog from "../../constant/commonImageDialog";

const ViewCustomer = () => {
  const {
    register,
    setValue,
    control,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  const [selectedImage, setSelectedImage] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();
  const [imagePreview, setImagePreview] = useState(null);
  const [open, setOpen] = useState(false);

  const customerState = useSelector(
    (state) => state?.customer?.viewCustomer?.data || {}
  );
  const customerList = customerState || [];

  const inputFields = [
    {
      name: "reg_no",
      label: "Register No",
      readOnly: true,
    },
    {
      name: "first_name",
      label: "First Name",
      readOnly: true,
    },
    {
      name: "last_name",
      label: "Last Name",
      readOnly: true,
    },
    {
      name: "email",
      label: "Email",
      readOnly: true,
    },
    {
      name: "contact",
      label: "Phone No",
      readOnly: true,
    },
    {
      name: "dob",
      label: "Date Of Birth",
      readOnly: true,
    },
    {
      name: "gender_type",
      label: "Gender",
      readOnly: true,
    },
    {
      name: "address",
      label: "Address",
      size: "extraLarge",
      readOnly: true,
    },
    // {
    //   name: "street",
    //   label: "Street",
    //   readOnly: true,
    // },
    {
      name: "country",
      label: "Country",
      type: "text",
      readOnly: true,
    },
    {
      name: "state",
      label: "State",
      type: "text",
      readOnly: true,
    },
    {
      name: "city",
      label: "City",
      type: "text",
      readOnly: true,
    },
    {
      name: "pincode",
      label: "Pincode",
      readOnly: true,
    },
    {
      name: "country_code",
      label: "Country Code",
      readOnly: true,
    },
    {
      name: "status",
      label: "Status",
      readOnly: true,
    },
  ];

  const handleCancel = () => {
    navigate(APP_LINK.CUSTOMERS);
  };

  useEffect(() => {
    if (id) {
      dispatch(customerViewRequest(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (customerList) {
      setValue("reg_no", customerList?.reg_no);
      setValue("first_name", customerList?.first_name);
      setValue("last_name", customerList?.last_name);
      setValue("email", customerList?.email);
      setValue("contact", customerList?.phone);
      setValue("dob", customerList?.dob);
      setValue("status", customerList?.status);
      setValue("address", customerList?.address);
      setValue("gender_type", customerList?.gender_type);
      // setValue("street", customerList?.street);
      setValue("pincode", customerList?.pincode);
      setValue("state", customerList?.MasterState?.state_name);
      setValue("city", customerList?.MasterCity?.city_name);
      setValue("country", customerList?.MasterCountry?.country_name);
      setValue("country_code", customerList?.country_code);
      const statusLabel =
        customerList?.status === 1
          ? "Active"
          : customerList?.status === 0
          ? "Pending"
          : "Inactive";
      setValue("status", statusLabel);

      const imageUrl = customerList?.prof_image;
      setImagePreview(imageUrl ? imageUrl : []);
    }
  }, [customerList, setValue]);

  const handleImageClick = (image) => {
    if (image !== uploadImage) {
      setSelectedImage(image);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container>
      <form>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={5}>
            <Box>
              <Typography
                variant="h5"
                gutterBottom
                sx={styles.title}
                className="headingTable"
              >
                <h1> Customer Profile </h1>
              </Typography>
            </Box>
            <Box>
              <StyledContainer>
                <img
                  src={imagePreview}
                  alt="Product"
                  width={150}
                  height={150}
                  style={styles.image}
                  onClick={() => handleImageClick(imagePreview)}
                />
              </StyledContainer>
            </Box>
          </Grid>

          {/* Form section */}
          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            <ReusableFormFields
              inputFields={inputFields}
              control={control}
              errors={errors}
              register={register}
              setValue={setValue}
              required={false}
            />
            <Box sx={styles.submitGap}>
              <Grid container spacing={2} item xs={12}>
                <Grid item xs={6}>
                  <CustomButton
                    text="Back"
                    size="medium"
                    onClick={handleCancel}
                    buttonStyle="StyledButton"
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </form>

      {/* Popup Dialog */}
      <ImagePreviewDialog
        open={open}
        onClose={handleClose}
        selectedImage={selectedImage}
      />
    </Container>
  );
};

export default ViewCustomer;
